import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import StoreCreditPanel from "./StoreCreditPanel";

type Props = {
    open: boolean;
    onClose: () => void;
    customerId: number | null;
    customerName?: string;
};

// Standalone store-credit dialog (used from the Store Credit dashboard page).
// The actual balance/grant/adjust/history UI lives in StoreCreditPanel, which is
// shared with the User Details "Store Credit" tab.
export default function StoreCreditDialog({ open, onClose, customerId, customerName }: Props) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Store Credit{customerName ? ` — ${customerName}` : ""}
            </DialogTitle>
            <DialogContent dividers>
                {open && customerId ? (
                    <StoreCreditPanel customerId={customerId} />
                ) : null}
            </DialogContent>
            <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={onClose}>Close</Button>
            </Box>
        </Dialog>
    );
}
